/**
 *
 * Asynchronously loads the component for Settings
 *
 */

import Loadable from 'react-loadable'
import React from 'react'
import LoadingIndicator from '@app/components/LoadingIndicator'

export default Loadable({
  loader: () => import('./index' /* webpackChunkName: "Settings" */),
  loading: () => <LoadingIndicator />
})
